@use '@/styles/tokens' as *;

.root {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  padding: var(--space-12) var(--space-6);
  text-align: center;
}

.icon {
  margin-bottom: var(--space-2);
  color: var(--status-danger);
}

.title {
  margin: 0;
  font-size: 16px;
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
}

.description {
  max-width: 340px;
  margin: 0 0 var(--space-3);
  font-size: 14px;
  color: var(--text-muted);
}
